import { render, staticRenderFns } from "./IntegerEligibilityInput.vue?vue&type=template&id=47f0c1f6"
import script from "./IntegerEligibilityInput.vue?vue&type=script&lang=js"
export * from "./IntegerEligibilityInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports